<!-- Shared Include / Exclude / Clear footer (Include blue #1363DF, Exclude/Clear
     red #D11044). `single` → Include only. `sc` → ng-select ref, closed on apply. -->
<ng-template #ieButtons let-c="c" let-single="single" let-sc="sc">
  <button
    type="button"
    class="du-multi-select-btn include"
    [class.disabled]="!canInclude(c)"
    [disabled]="!canInclude(c)"
    matTooltip="Include"
    matTooltipClass="emd-tip-mat"
    (click)="$event.stopPropagation(); applyInclude(c, sc)"
  >
    <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="7" width="8" height="3" fill="#1363DF" />
      <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
      <path d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z" fill="#1363DF" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z" fill="#1363DF" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z" fill="#1363DF" />
    </svg>
  </button>

  <button
    *ngIf="!single"
    type="button"
    class="du-multi-select-btn exclude"
    [class.disabled]="!canExclude(c)"
    [disabled]="!canExclude(c)"
    matTooltip="Exclude"
    matTooltipClass="emd-tip-mat"
    (click)="$event.stopPropagation(); applyExclude(c, sc)"
  >
    <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="8" height="3" fill="#D11044" />
      <rect y="12" width="8" height="3" fill="#D11044" />
      <path d="M11.1534 6.46002L5 6.46003L5 8.53998L11.1534 8.53998L8.76241 11.0228L10.185 12.5L15 7.5L10.185 2.5L8.76241 3.9772L11.1534 6.46002Z" fill="#D11044" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5 7H10V6.46003L5 6.46003V7ZM10 5.26234L8.78436 4H10V5.26234ZM4 7H2V4H7.76266C7.76816 4.24237 7.86131 4.48312 8.0421 4.67086L8.80207 5.46003L5 5.46003C4.44772 5.46003 4 5.90774 4 6.46003V7Z" fill="#D11044" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.78436 11H9V10.7761L8.78436 11ZM9 8.53998L5 8.53998V8H9V8.53998ZM7.76267 11H1V8H4V8.53998C4 9.09226 4.44772 9.53997 5 9.53998L8.80207 9.53998L8.0421 10.3291C7.86131 10.5169 7.76816 10.7576 7.76267 11Z" fill="#D11044" />
    </svg>
  </button>

  <button
    *ngIf="!single"
    type="button"
    class="du-multi-select-btn exclude"
    [class.disabled]="checkedOf(c).length === 0"
    [disabled]="checkedOf(c).length === 0"
    matTooltip="Clear selection"
    matTooltipClass="emd-tip-mat"
    (click)="clearChecked(c, $event)"
  >
    <svg width="25" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1233 0C15.6075 0 16 0.392499 16 0.876682C16 1.05902 15.9432 1.23684 15.8373 1.3854L12.2592 6.40765C11.9677 6.35237 11.6669 6.32344 11.3594 6.32344C8.70842 6.32344 6.55938 8.47248 6.55938 11.1234C6.55938 12.7503 7.3687 14.1881 8.60667 15.0562L7.97832 15.4751C7.19837 15.995 6.14461 15.7843 5.62468 15.0044C5.43971 14.7268 5.34054 14.401 5.33964 14.0675L5.32513 8.72486L0.159683 1.38108C-0.11886 0.985049 -0.0236423 0.438156 0.372391 0.159613C0.520046 0.055766 0.696221 0 0.876751 0H15.1233Z" fill="#D11044" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2 14.3219C12.9673 14.3219 14.4 12.8892 14.4 11.1219C14.4 9.35456 12.9673 7.92188 11.2 7.92188C9.43269 7.92188 8 9.35456 8 11.1219C8 12.8892 9.43269 14.3219 11.2 14.3219ZM11.5953 11.4889H12.8V10.7642H11.5953L11.6 10.7643H10.8L10.7953 10.7642H9.60001V11.4889L10.7953 11.4889L11.5953 11.4889Z" fill="#D11044" />
    </svg>
  </button>
</ng-template>

<!-- Dim backdrop behind the panel. -->
<div class="filter-panel-backdrop" *ngIf="open" (click)="close()"></div>

<aside
  class="filter-panel"
  [class.open]="open"
  #fpEl
  [style.width.px]="panelWidth"
  [style.--emd-accent]="accentColor || null"
>
  <div
    class="fp-resize"
    (resize)="onResizeSide($event)"
    [targetElement]="fpEl"
    [direction]="AngularResizeElementDirection.LEFT"
    matTooltip="Drag to resize"
  ></div>

  <!-- Launcher / close tab: the app's own filter panel uses a fixed blue funnel
       tab at the viewport's right edge (`.filterSides`, g_filter icon) to open and
       a blue tab on the panel's left edge (`.btn-close-bg`, `clear` icon) to
       close. Both sit in the same place, so one element covers both states. -->
  <div
    class="fp-toggle"
    (click)="toggle()"
    [matTooltip]="open ? 'Close' : 'Filter'"
    matTooltipClass="emd-tip-mat"
  >
    <span class="fp-toggle-icon">
      <mat-icon *ngIf="!open" svgIcon="g_filter"></mat-icon>
      <mat-icon *ngIf="open">clear</mat-icon>
    </span>
  </div>

  <h2 class="fp-title">Filter</h2>
  <hr class="fp-hr" />

  <div class="fp-body">
    <!-- Dimension filters -->
    <div class="fp-field" *ngFor="let c of chips">
      <label class="fp-flabel">{{ c.label }}</label>

      <!-- Single (Brand / NDC) -->
      <ng-select
        *ngIf="!c.multi"
        #scS
        class="ngSelection fp-select"
        [multiple]="false"
        [clearable]="false"
        [closeOnSelect]="false"
        [dropdownPosition]="'auto'"
        [appendTo]="'.filter-panel'"
        [items]="c.options"
        [ngModel]="checkedOf(c)[0] || null"
        (ngModelChange)="onSingleModel(c, $event)"
        (close)="onSelectClose(c)"
        [placeholder]="'Select ' + c.label"
      >
        <ng-template ng-header-tmp>
          <input class="searchFiler" type="text" placeholder="Search" (input)="scS.filter(onFilterText($event))" />
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <div class="du-opt">
            <input type="checkbox" [checked]="item$.selected" />
            <label>{{ item }}</label>
          </div>
        </ng-template>
        <ng-template ng-footer-tmp>
          <div class="fp-ie">
            <ng-container *ngTemplateOutlet="ieButtons; context: ieContext(c, true, scS)"></ng-container>
          </div>
        </ng-template>
      </ng-select>

      <!-- Multi -->
      <ng-select
        *ngIf="c.multi"
        #scM
        class="ngSelection fp-select"
        [multiple]="true"
        [clearable]="false"
        [closeOnSelect]="false"
        [dropdownPosition]="'auto'"
        [appendTo]="'.filter-panel'"
        [items]="c.options"
        [ngModel]="checkedOf(c)"
        (ngModelChange)="setChecked(c, $event)"
        (close)="onSelectClose(c)"
        [placeholder]="'Select ' + c.label"
      >
        <ng-template ng-header-tmp>
          <input class="searchFiler" type="text" placeholder="Search" (input)="scM.filter(onFilterText($event))" />
          <label class="multiselect-form-check">
            <input type="checkbox" [checked]="allChecked(c)" (click)="toggleSelectAll(c, $event)" />
            <span>Select All</span>
          </label>
        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items">
          <div class="ng-value" *ngFor="let it of items | slice: 0 : itemsShowLimit">
            <span class="ng-value-label">{{ it }}</span>
          </div>
          <div class="ng-value" *ngIf="items.length > itemsShowLimit">
            <span class="ng-value-label">{{ items.length - itemsShowLimit }} more...</span>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <div class="du-opt">
            <input type="checkbox" [checked]="item$.selected" />
            <label>{{ item }}</label>
          </div>
        </ng-template>
        <ng-template ng-footer-tmp>
          <div class="fp-ie">
            <ng-container *ngTemplateOutlet="ieButtons; context: ieContext(c, false, scM)"></ng-container>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <!-- Time Range (day-grained; EMD data is weekly so no cycle selector) -->
    <div class="fp-field">
      <label class="fp-flabel">From Date</label>
      <mat-form-field class="fp-datepick" appearance="fill">
        <input
          matInput
          readonly
          [min]="minFromDate"
          [max]="maxFromDate"
          [ngModel]="fromDateObj"
          [matDatepicker]="fromPicker"
          (dateChange)="onFromPicked($event.value)"
        />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker panelClass="emd-fp-cal"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="fp-field">
      <label class="fp-flabel">To Date</label>
      <mat-form-field class="fp-datepick" appearance="fill">
        <input
          matInput
          readonly
          [min]="minToDate"
          [max]="maxToDate"
          [ngModel]="toDateObj"
          [matDatepicker]="toPicker"
          (dateChange)="onToPicked($event.value)"
        />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker panelClass="emd-fp-cal"></mat-datepicker>
      </mat-form-field>
    </div>

    <hr class="fp-hr" />
    <!-- Same Reset chip the reference renders at the bottom of its filter block:
         `x_mark` svg icon (registered globally by IconService) + "Reset". -->
    <div class="fp-reset-row" *ngIf="anyPartial">
      <span class="fp-reset-chip" (click)="resetFilters()">
        <mat-icon class="fp-reset-icon" svgIcon="x_mark"></mat-icon>Reset
      </span>
    </div>
  </div>
</aside>
